export var imageTheme = {
  baseStyle: _ref => {
    var {
      objectFit,
      objectPosition,
      aspectRatio,
      borderRadius,
      width,
      height
    } = _ref;
    return {
      image: {
        width,
        height,
        objectFit,
        objectPosition,
        aspectRatio,
        borderRadius,
        _disabled: {
          opacity: 0.35
        }
      },
      fallbackImage: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'neutral.lightest',
        height,
        width,
        objectFit,
        objectPosition,
        aspectRatio,
        borderRadius
      },
      fallbackIcon: {
        width: '100%',
        height: '100%',
        maxWidth: '40px',
        maxHeight: '40px'
      }
    };
  },
  variants: {
    circle: {
      image: {
        borderRadius: 'full',
        aspectRatio: '1 / 1'
      }
    },
    square: {}
  }
};
//# sourceMappingURL=Image.theme.js.map